export default __webpack_public_path__ + "static/media/M2_Dppp.92655b88.png";